import { Metamodel } from '../base/model';
import { IAttribute, IModel, Owned, ParameterConfig } from 'shell-models-lib';


export type FullScriptMode = 'Query' | 'NonQuery';

@Metamodel.model({
    name: 'PlainScript'
})
export class PlainScript extends Owned {
    public static readonly MODEL: IModel;
    public static readonly SCRIPT_PARAMETERS: IAttribute;
    public static readonly SCRIPT_QUERY_MODE: IAttribute;
    public static readonly SCRIPT_TEXT: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ScriptLabel,
        templatable: true,
        association: 'SCRIPT_QUERY_MODE'
    })
    public type: FullScriptMode = 'Query';

    @Metamodel.attribute({
        display: '',
        templatable: true,
        association: 'SCRIPT_TEXT'
    })
    public text: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ScriptParameters,
        accepts: ['Object', 'Array'],
        association: 'SCRIPT_PARAMETERS'
    })
    public scriptParams?: ParameterConfig[];

    constructor() {
        super();
    }
}
